import React from "react";

const NotFound = () => {
  return (
    <div>
      <img
        className="w-[100vw]"
        src="https://kfg6bckb.media.zestyio.com/yalantis-interactive-404.gif"
        alt=""
      />
    </div>
  );
};

export default NotFound;
